import MuiIcon, { IconProps as MuiIconProps } from '@material-ui/core/Icon';
import { withStyles } from '@material-ui/core/styles';

type IconProps = MuiIconProps;
const Icon = withStyles<'root', {}, IconProps>(
  {
    root: {
      '&.fa': {
        fontFamily: 'FontAwesome'
      },
      '&.ei': {
        fontFamily: 'ElegantIcons',
        height: '24px',
        width: '24px',
        overflow: 'visible'
      },
      '&.MuiIcon-fontSizeLarge': {
        '&.fa, &.ei': {
          height: '36px',
          width: '36px'
        }
      }
    }
  },
  { name: 'FdIcon' }
)(MuiIcon);

export default Icon;
